import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取工单列表
 * @param params
 */
export const getWorkorderListApi = (params:object = {}) => $http.get(`/admin/shops/shop_work_list`, params)

/**
 * 获取工单详情
 * @param params
 */
export const getWorkorderInfoApi = (work_id: any) => $http.get(`/admin/shops/get_shop_work_detail`, { work_id })

/**
 * 保存工单处理结果
 * @param data
 */
export const saveWorkorderApi = (data:object) => $http.post('/admin/shops/do_shop_work', data)

/**
 * 获取当前登录用户新工单
 * @param params
 */
export const getUnResolveWorkorderApi = () => $http.get('/admin/shops/work_notice', { notShowLoading: true })

/**
 * 获取当前登录用户工单审核状态
 * @param params
 */
export const getWorkorderCheckStatusApi = () => $http.get('/admin/shops/work_notice_auth', { notShowLoading: true })